export default "__VITE_ASSET__453f172e__"